<template>
  <v-form lazy-validation v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" sm="12" md="11" lg="11">
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Customer <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  item-text="name"
                  item-value="id"
                  return-object
                  :items="customers"
                  v-model="customer"
                  @change="onChangeCustomer"
                  :rules="[v => !!v || 'Customer is required']"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Voucher Number <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model.number="voucherNumber"
                  :rules="[v => !!v || 'Voucher is required']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Method<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-select
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.method"
                  :items="listMethod"
                  @change="onChangeMethod"
                  :rules="[v => !!v || 'Method is required']"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Pay Date<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-menu
                  v-model="menuPayDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="form.payDate"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.payDate"
                    :allowed-dates="getAllowedDates()"
                    @input="menuPayDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Bank Account<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  item-text="accountName"
                  v-model="bank"
                  :items="listBank"
                  return-object
                  @change="onChangeBank"
                  :rules="[v => !!v || 'Bank is required']"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Total Paid (Bank)</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model.number="form.bankAmount"
                  prefix="Rp."
                  append-outer-icon="mdi-calculator"
                  @click:append-outer="calculation"
                  :rules="[v => v >= 0 || 'Total Paid must more than equal 0']"
                  persistent-hint
                  :hint="formatPrice(form.bankAmount)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Bank Charges<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model.number="form.bankCharge"
                  prefix="Rp."
                  @change="onChangeBankCharge"
                  :rules="[v => v >= 0 || 'Bank charge must more than equals 0']"
                  persistent-hint
                  :hint="formatPrice(form.bankCharge)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" v-if="form.method === 'Giro'">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Giro<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-btn color="success" @click="addGiro" class="mr-2">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" v-if="form.method === 'Check'">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Check<span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-btn color="success" @click="addCheck" class="mr-2">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Pembulatan</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-text-field
                  type="number"
                  outlined
                  flat
                  dense
                  background-color="white"
                  prefix="Rp."
                  v-model.number="form.roundAmount"
                  :disabled="form.round === 'None'"
                  :rules="[v => v >= 0 || 'Round Amount must more than equals 0']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" class="py-0">
                <v-select
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.round"
                  :items="listRound"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
                <v-subheader>Remark</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6" class="py-0">
                <v-textarea
                  outlined
                  flat
                  rows="3"
                  background-color="white"
                  v-model="form.remark"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-tabs vertical>
              <v-tab background-color="light-blue accent-3" dark class="px-0">
                <v-icon>
                  mdi-note-text
                </v-icon>
              </v-tab>
              <v-tab>
                <v-icon>
                  mdi-information
                </v-icon>
              </v-tab>
              <v-tab v-if="form.method === 'Giro'">
                <v-icon>
                  mdi-information
                </v-icon>
              </v-tab>
              <v-tab v-if="form.method === 'Check'">
                <v-icon>
                  mdi-information
                </v-icon>
              </v-tab>
              <v-tab-item>
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="6">
                      <v-autocomplete
                        outlined
                        flat
                        dense
                        background-color="white"
                        append-icon="mdi-magnify"
                        item-text="invoiceNumber"
                        return-object
                        v-model="invoice"
                        :items="listInvoice"
                        :rules="[v => !!v || 'Invoice is required']"
                      >
                        <template v-slot:item="data">
                          <v-list-item v-on="data.on" @click.stop="onChangeInvoice(data.item)">
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="data.item.invoiceNumber"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6" align-self="start" class="text-right pb-0">
                      <p class="headline font-italic">
                        Invoice Detail <span class="red--text">*</span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        disable-pagination
                        hide-default-footer
                        @click:row="onClickRow"
                      >
                        <template v-slot:item.no="{ item }">
                          {{ items.map(x => x).indexOf(item) + 1 }}
                        </template>
                        <template v-slot:item.totalAmountAfterTax="{ item }">
                          {{ formatPrice(item.totalAmountAfterTax) }}
                        </template>
                        <template v-slot:item.rateInvoice="{ item }">
                          {{ formatPrice(item.rateInvoice) }}
                        </template>
                        <template v-slot:item.totalInvoiceIDR="{ item }">
                          {{ formatPrice(item.totalInvoiceIDR) }}
                        </template>
                        <template v-slot:item.ratePay="{ item }">
                          {{ formatPrice(item.ratePay) }}
                        </template>
                        <template v-slot:item.totalInvoicePaid="{ item }">
                          {{ formatPrice(item.totalInvoicePaid) }}
                        </template>
                        <template v-slot:item.totalInvoicePaidIDR="{ item }">
                          {{ formatPrice(item.totalInvoicePaidIDR) }}
                        </template>
                        <template v-slot:item.pph22Amount="{ item }">
                          {{ formatPrice(item.pph22Amount) }}
                        </template>
                        <template v-slot:item.pph23Amount="{ item }">
                          {{ formatPrice(item.pph23Amount) }}
                        </template>
                        <template v-slot:item.fineAmount="{ item }">
                          {{ formatPrice(item.fineAmount) }}
                        </template>
                        <template v-slot:item.fullPayment="{ item }">
                          {{ item.fullPayment ? "YES" : "NO" }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-title class="font-italic">Additional Info</v-card-title>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2" class="pb-0">
                      <v-subheader>Bill To</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4" class="pb-0">
                      <span>{{ form.billTo }}</span>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="form.method === 'Giro'">
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="6"> </v-col>
                    <v-col cols="6" align-self="start" class="text-right pb-0">
                      <p class="headline font-italic">Giro <span class="red--text">*</span></p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headerGiro"
                        :items="form.giros"
                        disable-pagination
                        hide-default-footer
                        @click:row="onClickRowGiro"
                      >
                        <template v-slot:item.no="{ index }">
                          {{ index + 1 }}
                        </template>
                        <template v-slot:item.amount="{ item }">
                          {{ formatPrice(item.amount) }}
                        </template>
                        <template v-slot:item.action="{ index }">
                          <v-btn icon color="red" @click="deleteMethod(index)">
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="form.method === 'Check'">
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="6"> </v-col>
                    <v-col cols="6" align-self="start" class="text-right pb-0">
                      <p class="headline font-italic">Check <span class="red--text">*</span></p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-data-table
                        :headers="headerCheck"
                        :items="form.checks"
                        disable-pagination
                        hide-default-footer
                        @click:row="onClickRowCheck"
                      >
                        <template v-slot:item.no="{ index }">
                          {{ index + 1 }}
                        </template>
                        <template v-slot:item.amount="{ item }">
                          {{ formatPrice(item.amount) }}
                        </template>
                        <template v-slot:item.action="{ index }">
                          <v-btn icon color="red" @click="deleteMethod(index)">
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="1" lg="1" class="py-0">
        <v-row class="py-0">
          <v-col cols="12" class="mb-4 py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="checkJournal">
                  <v-icon large>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-sale-invoice
      :item="item"
      :index="index"
      :dialog="dialog"
      @close="close"
      @save="addItem"
      @deleteItem="deleteItem"
    ></dialog-sale-invoice>
    <dialog-review-journal
      :dialog="dialogReview"
      :journals="journals"
      @save="submit"
      @close="close"
      currency="IDR"
    ></dialog-review-journal>
    <dialog-method
      :dialog="dialogMethod"
      :item="methodItem"
      @save="saveMethod"
      @close="close"
      :type="typeMethod"
    ></dialog-method>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import DialogSaleInvoice from "@/components/DialogSaleInvoice";
import DialogReviewJournal from "@/components/DialogReviewJournal";
import DialogMethod from "@/components/DialogMethod";
import { fiscalMonthMixin } from "@/services/mixins/fiscalMonthMixin";

export default {
  name: "create-sale-payment",
  mixins: [fiscalMonthMixin],
  components: {
    "dialog-sale-invoice": DialogSaleInvoice,
    DialogReviewJournal,
    DialogMethod,
  },
  data: () => ({
    defaultForm: {
      formNumber: "",
      voucherNumber: 0,
      payDate: moment().format("yyyy-MM-DD"),
      customerId: null,
      customerName: null,
      method: "",
      remark: "",
      bankId: null,
      billTo: "",
      bankAmount: 0,
      bankCharge: 0,
      invoices: [],
      checks: [],
      giros: [],
      status: "Outstanding",
      round: "None",
      roundAmount: 0,
    },
    menuPayDate: false,
    form: {},
    items: [],
    customer: null,
    bank: null,
    dialog: false,
    dialogReview: false,
    dialogMethod: false,
    item: {},
    invoice: {},
    listInvoice: [],
    journals: [],
    index: -1,
    valid: true,
    typeMethod: "",
    methodItem: {},
    accountNumber: "",
    headers: [
      {
        text: "No",
        value: "no",
        sortable: false,
        divider: true,
      },
      {
        text: "Invoice #",
        value: "invoiceNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "Invoice Date",
        value: "invoiceDate",
        sortable: false,
        divider: true,
      },
      {
        text: "Currency",
        value: "currency",
        sortable: false,
        divider: true,
      },
      {
        text: "Amount",
        value: "totalAmountAfterTax",
        sortable: false,
        divider: true,
      },
      {
        text: "Rate (Invoice)",
        value: "rateInvoice",
        sortable: false,
        divider: true,
      },
      {
        text: "Total Invoice (RP)",
        value: "totalInvoiceIDR",
        sortable: false,
        divider: true,
      },
      {
        text: "Rate (Pay)",
        value: "ratePay",
        sortable: false,
        divider: true,
      },
      {
        text: "Invoice Paid",
        value: "totalInvoicePaid",
        sortable: false,
        divider: true,
      },
      {
        text: "Total Paid (RP)",
        value: "totalInvoicePaidIDR",
        sortable: false,
        divider: true,
      },
      {
        text: "PPh Psl 22",
        value: "pph22Amount",
        sortable: false,
        divider: true,
      },
      {
        text: "PPh Psl 23",
        value: "pph23Amount",
        sortable: false,
        divider: true,
      },
      {
        text: "Penalty",
        value: "fineAmount",
        sortable: false,
        divider: true,
      },
      {
        text: "Full Payment",
        value: "fullPayment",
        sortable: false,
        divider: true,
      },
      {
        text: "Pay For",
        value: "payFor",
        sortable: false,
        divider: true,
      },
    ],
    headerGiro: [
      {
        text: "No",
        value: "no",
        sortable: false,
        divider: true,
      },
      {
        text: "Giro Number",
        value: "giroNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "Bank",
        value: "bankName",
        sortable: false,
        divider: true,
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false,
        divider: true,
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        divider: true,
      },
    ],
    headerCheck: [
      {
        text: "No",
        value: "no",
        sortable: false,
        divider: true,
      },
      {
        text: "Check Number",
        value: "checkNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "Bank",
        value: "bankName",
        sortable: false,
        divider: true,
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false,
        divider: true,
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        divider: true,
      },
    ],
    listMethod: ["TT", "Check", "Cash", "Giro", "Transfer"],
    listBank: [],
    listRound: ["None", "UP", "DOWN"],
  }),

  computed: {
    ...mapState("external", ["customers"]),
    ...mapState("salePayment", ["lastFormNumber", "voucherNumber"]),
    totalPaid() {
      let total = 0;
      this.items.forEach(x => {
        if (x.fullPayment) {
          total += x.totalInvoicePaidIDR;
        }
      });
      return parseFloat(total.toFixed(2));
    },
    totalPph23() {
      let total = 0;
      this.items.forEach(x => {
        if (x.fullPayment) {
          total += x.pph23Amount;
        }
      });
      return parseFloat(total.toFixed(2));
    },
  },

  methods: {
    checkJournal() {
      if (this.$refs.form.validate() && this.items.length > 0) {
        let totalPph22 = 0;
        let totalPph23 = 0;
        let penalty = 0;
        let totalPaid = 0;
        this.items.forEach(x => {
          totalPph22 += x.pph22Amount;
          totalPph23 += x.pph23Amount;
          penalty += x.fineAmount;
          totalPaid += x.totalInvoicePaid;
        });
        this.journals = [
          {
            accountNumber: this.bank.accountNumber,
            accountName: this.bank.accountName,
            debit: this.form.bankAmount,
            credit: 0,
          },
          {
            accountNumber: this.accountNumber,
            accountName: `${this.form.customerName} IDR`,
            debit: 0,
            credit: totalPaid,
          },
        ];
        if (this.form.bankCharge > 0) {
          this.journals.unshift({
            accountNumber: "916.00001",
            accountName: `BIAYA ADMINISTRASI BANK`,
            debit: this.form.bankCharge,
            credit: 0,
          });
        }
        if (totalPph22 > 0) {
          this.journals.unshift({
            accountNumber: "180.00002",
            accountName: `PAJAK PPH 22`,
            debit: totalPph22,
            credit: 0,
          });
        }
        if (totalPph23 > 0) {
          this.journals.unshift({
            accountNumber: "180.00003",
            accountName: `PAJAK PPH 23`,
            debit: totalPph23,
            credit: 0,
          });
        }
        if (penalty > 0) {
          this.journals.unshift({
            accountNumber: "980.00002",
            accountName: `BIAYA DENDA`,
            debit: penalty,
            credit: 0,
          });
        }
        if (this.form.round === "UP") {
          this.journals.unshift({
            accountNumber: "691.00000",
            accountName: "SELISIH KURS",
            debit: this.form.roundAmount,
            credit: 0,
          });
        } else if (this.form.round === "DOWN") {
          this.journals.push({
            accountNumber: "691.00000",
            accountName: "SELISIH KURS",
            debit: 0,
            credit: this.form.roundAmount,
          });
        }
        this.journals.forEach(x => {
          this.$store
            .dispatch("chartOfAccount/getPointer", { accountNumber: x.accountNumber })
            .then(response => (x.pointers = response.data));
        });
        this.dialogReview = true;
      } else {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Items is required",
        });
      }
    },
    submit() {
      if (this.$refs.form.validate() && this.items.length > 0) {
        this.form.formNumber = this.lastFormNumber;
        this.form.voucherNumber = this.voucherNumber;
        this.form.invoices = this.items;

        let totalDebit = this.form.bankAmount + this.form.bankCharge;
        let totalCredit = 0;

        this.items.forEach(x => {
          totalDebit += x.fineAmount + x.pph22Amount + x.pph23Amount;
        });

        this.items.forEach(x => {
          totalCredit += x.totalInvoicePaid;
        });

        if (this.form.round === "UP") {
          totalDebit += this.form.roundAmount;
        } else if (this.form.round === "DOWN") {
          totalCredit += this.form.roundAmount;
        }

        if (parseFloat(totalDebit.toFixed(2)) - parseFloat(totalCredit.toFixed(2)) === 0) {
          this.$store.commit("SET_LOADER", true);
          this.$store
            .dispatch("salePayment/create", { body: this.form, type: "create" })
            .then(() => this.$store.commit("SET_LOADER", false))
            .catch(() => {
              this.$store.dispatch("toast", {
                type: "error",
                message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
              });
              this.$store.commit("SET_LOADER", false);
            });
          this.clear();
        } else {
          let different = totalDebit - totalCredit;
          if (different > 0) {
            this.$store.dispatch("toast", {
              type: "error",
              message: `Journal not balance with -${Math.abs(different)} on Debit`,
            });
          } else {
            this.$store.dispatch("toast", {
              type: "error",
              message: `Journal not balance with -${Math.abs(different)} on Dredit`,
            });
          }
        }
      } else {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Invoices is required",
        });
      }
    },
    async getAR(id) {
      await this.$store
        .dispatch("chartOfAccount/getAR", id)
        .then(response => (this.accountNumber = response.data));
    },
    onChangeCustomer(val) {
      this.form.customerId = val.id;
      this.form.customerName = val.name;
      this.form.billTo = val.name;
      this.getAdditionalDataFromCustomerId(val.id);
      this.getAR(val.id);
    },
    onChangeInvoice(item) {
      if (this.items.indexOf(item) > -1) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Invoices Already Used on Form",
        });
      } else {
        this.items.push(item);
        this.item = item;
        this.index = this.items.map(x => x).indexOf(item);
        this.dialog = true;
      }
    },
    async getAdditionalDataFromCustomerId(id) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("salePayment/getListInvoice", id)
        .then(response => {
          this.listInvoice = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    getBanks() {
      this.$store.dispatch("chartOfAccount/getBanks").then(response => {
        this.listBank = response.data;
      });
    },
    onClickRow(item) {
      this.item = item;
      this.index = this.items.map(x => x).indexOf(item);
      this.dialog = true;
    },
    onClickRowCheck(item) {
      this.methodItem = item;
      this.index = this.form.checks.indexOf(item);
      this.dialogMethod = true;
    },
    onClickRowGiro(item) {
      this.methodItem = item;
      this.index = this.form.giros.indexOf(item);
      this.dialogMethod = true;
    },
    close() {
      this.dialog = false;
      this.dialogReview = false;
      this.dialogMethod = false;
    },
    deleteItem(index) {
      if (index > -1) {
        this.items.splice(index, 1);
        this.dialog = false;
      }
    },
    addItem(data) {
      this.items[data.index] = data.item;
    },
    clear() {
      this.customer = null;
      this.items = [];
      this.form = Object.assign({}, this.defaultForm);
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    calculation() {
      if (this.items.length > 0) {
        if (this.totalPaid > 0) {
          let total = parseFloat(
            (this.totalPaid - (this.form.bankAmount + this.totalPph23)).toFixed(2)
          );
          if (total > 0) {
            this.form.round = "UP";
            this.form.roundAmount = total;
          } else if (total < 0) {
            this.form.round = "DOWN";
            this.form.roundAmount = Math.abs(total);
          } else {
            this.form.round = "None";
            this.form.roundAmount = 0;
          }
        }
      } else {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Invoice is Required",
        });
      }
    },
    onChangeBank(val) {
      this.form.bankId = val.accountId;
    },
    onChangeBankCharge(val) {
      if (this.form.bankAmount > 0) {
        this.form.bankAmount -= val;
      }
    },
    onChangeMethod(val) {
      if (val !== "Giro" || val !== "Check") {
        this.methodItem = {};
        this.form.giros = [];
        this.form.check = [];
      }
    },
    addGiro() {
      this.methodItem = {
        giroNumber: "",
        bankName: "",
        amount: 0,
      };
      this.typeMethod = "Giro";
      this.dialogMethod = true;
    },
    addCheck() {
      this.methodItem = {
        checkNumber: "",
        bankName: "",
        amount: 0,
      };
      this.typeMethod = "Check";
      this.dialogMethod = true;
    },
    saveMethod() {
      if (this.typeMethod === "Giro") {
        if (this.form.giros.length > 0) {
          this.form.giros[this.index] = this.methodItem;
        } else {
          this.form.giros.push(this.methodItem);
        }
      } else {
        if (this.form.checks.length > 0) {
          this.form.checks[this.index] = this.methodItem;
        } else {
          this.form.checks.push(this.methodItem);
        }
      }
    },
    deleteMethod(index) {
      if (index > -1) {
        if (this.typeMethod === "Giro") {
          this.form.giros.splice(index, 1);
        } else {
          this.form.checks.splice(index, 1);
        }
      }
    },
    getInitialData() {
      this.$store.commit("SET_LOADER", true);
      Promise.all([
        this.$store.dispatch("salePayment/getLastFormNumber"),
        this.$store.dispatch("salePayment/getVoucherNumber"),
        this.$store.dispatch("external/getCustomers"),
        this.getBanks(),
      ])
        .then(() => this.$store.commit("SET_LOADER", false))
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },

  mounted() {
    this.getInitialData();
    this.form = Object.assign({}, this.defaultForm);
  },
};
</script>

<style></style>
